import React from 'react';
import { DocumentMagnifyingGlassIcon } from '../../icons';
import { formatDateTime } from '../../utils/transcriptionMeta';
import { getReasonLabel } from '../../utils/regeneration';

const RegenerationAuditPanel = ({ transcription }) => {
  if (!transcription?.is_regenerated && !transcription?.regeneration_reason) {
    return null;
  }

  const reasonLabel =
    transcription.regeneration_reason_label ||
    getReasonLabel(transcription.regeneration_reason);

  return (
    <div className="md-alert md-alert-warning mb-4">
      <div className="flex items-start gap-3">
        <DocumentMagnifyingGlassIcon className="h-5 w-5 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="font-semibold">Regeneration audit</h3>
          <dl className="mt-2 space-y-1">
            {reasonLabel && (
              <div>
                <dt className="inline opacity-80">Reason: </dt>
                <dd className="inline">{reasonLabel}</dd>
              </div>
            )}
            {transcription.regeneration_requested_by && (
              <div>
                <dt className="inline opacity-80">Requested by: </dt>
                <dd className="inline">{transcription.regeneration_requested_by}</dd>
              </div>
            )}
            {(transcription.regenerated_at || transcription.created_at) && (
              <div>
                <dt className="inline opacity-80">Generated: </dt>
                <dd className="inline">
                  {formatDateTime(transcription.regenerated_at || transcription.created_at)}
                </dd>
              </div>
            )}
            {transcription.parent_transcription_id && (
              <div>
                <dt className="inline opacity-80">Source version: </dt>
                <dd className="inline font-mono text-xs">
                  {transcription.parent_transcription_id}
                </dd>
              </div>
            )}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default RegenerationAuditPanel;
